import { Component, Input } from '@angular/core'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Profession } from '../../models/profession.interface'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Filter, QueryGet } from '../../shared/query-types'
import { ProfessionService } from '../../services/profession/profession.service'
import { PAGINATION } from '../../shared/constants'
import { AsyncPipe, CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { ProfessionFormComponent } from '../profession-form/profession-form.component'
import { MatDialog } from '@angular/material/dialog'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-profession-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './profession-list.component.html',
    styleUrl: './profession-list.component.css',
})
export class ProfessionListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    professionList: Profession[] = []
    selectedProfession: Profession | null = null
    asyncProfession!: Observable<Pagination<Profession[]>>
    showColumns: string[] = [
        'acciones',
        'personalData',
        'name',
        'isLeader',
        'leaderRole',
        'companyName',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private professionService: ProfessionService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private title: Title
    ) {this.title.setTitle('Profesión')}

    fetchProfession(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncProfession = this.professionService
            .allProfesions(params)
            .pipe(
                tap((response) => {
                    this.professionList = response.results
                    this.professionService.setProfesions(response.results)
                    this.total = response.count
                }),
                map((res) => {
                    this.loadingService.show(false)
                    return res
                }),
                catchError((error) => {
                    this.loadingService.show(false)
                    this.router.navigate(['home/'])
                    return []
                })
            )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchProfession(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(profession: Profession): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar la profesión: ${profession.name}?`
        )
        if (!confirmed) return
        this.professionService.deleteProfesion(profession.id).subscribe({
            next: () => {
                const successMsg = `Eliminado CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchProfession(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar', 'Error')
            },
        })
    }

    updateProfession(profession: Profession) {
        this.professionService.setprofession(profession)
        const dialogRef = this.dialog.open(ProfessionFormComponent, {
            data: { selectedProfession: this.selectedProfession },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchProfession(PAGINATION.first_page)
        })
    }
    create(): void {}
}
